// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   GLOBÁLNÍ RESET & STRUKTURA - FIX PRO ČERNÉ OKRAJE NA MOBILU
   ========================================================================== */
html, body, #root {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
  /* Fix pro správné roztažení v mobilních prohlížečích Safari a Chrome */
  min-height: -webkit-fill-available; 
  /* Vynutí, aby podklad webu byl čistě bílý a neprosvítala tam černá */
  background-color: #ffffff !important; 
}

body {
  /* Zamezí gumovému efektu při scrollování na mobilu (odskakování horní/dolní lišty), 
     který způsoboval blikání černých pruhů */
  overscroll-behavior-y: none;
}

html {
  scroll-behavior: smooth;
}

/* ==========================================================================
   SLAĎENÝ STYL PRO LEVÝ PANEL (SIDEBAR) – PODLE HORNÍ LIŠTY
   ========================================================================== */

/* 1. Pozadí panelu: Čistá, velmi tmavá antracitová barva přesně podle horní lišty */
.sidebar-pattern {
  background-image: none !important; /* Definitivně maže ty staré čtverečky */
  background: #1e293b !important; /* Tmavý elegantní podklad odpovídající vršku */
  background-color: #1e293b !important;
  backdrop-filter: none !important; /* Už není potřeba rozmazávat fotku, panel je plný */
  border-right: 1px solid rgba(255, 255, 255, 0.05) !important;
}

/* 2. Vynucený reset pro všechny položky v menu (Obyčejný stav) */
.sidebar-pattern a, 
.sidebar-pattern button,
.sidebar-pattern [role="button"] {
  font-size: 1.05rem !important;
  color: #cbd5e1 !important; /* Příjemná světle šedá textu */
  transition: all 0.25s ease-out !important;
  padding: 12px 20px !important;
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  border-radius: 0px !important; /* Zrušíme ty kulaté modré pilulky */
  background-image: none !important;
  text-decoration: none !important;
}

/* 3. Efekt při najetí myší (Hover) */
.sidebar-pattern a:hover,
.sidebar-pattern button:hover {
  color: #4ade80 !important; /* Text se rozsvítí kempově zelenou */
  background: rgba(255, 255, 255, 0.03) !important;
  background-color: rgba(255, 255, 255, 0.03) !important;
  padding-left: 26px !important; /* Stylové odskočení doprava při najetí */
}

/* 4. ABSOLUTNÍ PŘEBITÍ PRO AKTIVNÍ KARTU (Zelené zvýraznění) */
.sidebar-pattern [class*="bg-blue"],
.sidebar-pattern .active,
.sidebar-pattern [aria-current="page"],
.sidebar-pattern [class*="active"] {
  color: #4ade80 !important; /* Zelený text */
  font-weight: 700 !important; /* Tučné písmo */
  
  /* Jemný zelený nádech pod textem, aby karta vystoupila z tmavého pozadí */
  background: rgba(74, 222, 128, 0.12) !important; 
  background-color: rgba(74, 222, 128, 0.12) !important;
  
  /* Elegantní zelená svítící linka na levém okraji karty */
  border-left: 5px solid #4ade80 !important; 
  padding-left: 26px !important; /* Karta zůstane mírně vysunutá */
  border-radius: 0px !important;
}

/* Pojistka: Pokud jsou ikonky nebo texty schované uvnitř, donutíme je svítit zeleně taky */
.sidebar-pattern [class*="bg-blue"] *,
.sidebar-pattern .active *,
.sidebar-pattern [class*="active"] * {
  color: #4ade80 !important;
  fill: #4ade80 !important; /* Pro SVG ikony */
}

/* ==========================================================================
   ZBYTEK STYLŮ (Původní funkční nastavení)
   ========================================================================== */

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Animation for sections */
section {
  animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Input styles */
input[type="text"] {
  transition: all 0.3s ease;
}

input[type="text"]:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.hover-lift {
  transition: transform 0.3s ease;
}

.hover-lift:hover {
  transform: translateY(-5px);
}

.animate-fadeIn {
  animation: lightboxFadeIn 0.2s ease-out;
}

@keyframes lightboxFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;+EAE+E;AAC/E;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uEAAuE;EACvE,kCAAkC;EAClC,qEAAqE;EACrE,oCAAoC;AACtC;;AAEA;EACE;6CAC2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;+EAE+E;;AAE/E,oFAAoF;AACpF;EACE,iCAAiC,EAAE,wCAAwC;EAC3E,8BAA8B,EAAE,+CAA+C;EAC/E,oCAAoC;EACpC,gCAAgC,EAAE,oDAAoD;EACtF,4DAA4D;AAC9D;;AAEA,iEAAiE;AACjE;;;EAGE,6BAA6B;EAC7B,yBAAyB,EAAE,+BAA+B;EAC1D,yCAAyC;EACzC,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,6BAA6B,EAAE,oCAAoC;EACnE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA,qCAAqC;AACrC;;EAEE,yBAAyB,EAAE,qCAAqC;EAChE,gDAAgD;EAChD,sDAAsD;EACtD,6BAA6B,EAAE,yCAAyC;AAC1E;;AAEA,+DAA+D;AAC/D;;;;EAIE,yBAAyB,EAAE,gBAAgB;EAC3C,2BAA2B,EAAE,gBAAgB;;EAE7C,0EAA0E;EAC1E,+CAA+C;EAC/C,qDAAqD;;EAErD,yDAAyD;EACzD,yCAAyC;EACzC,6BAA6B,EAAE,iCAAiC;EAChE,6BAA6B;AAC/B;;AAEA,2FAA2F;AAC3F;;;EAGE,yBAAyB;EACzB,wBAAwB,EAAE,kBAAkB;AAC9C;;AAEA;;+EAE+E;;AAE/E,qBAAqB;AACrB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["/* ==========================================================================\n   GLOBÁLNÍ RESET & STRUKTURA - FIX PRO ČERNÉ OKRAJE NA MOBILU\n   ========================================================================== */\nhtml, body, #root {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  min-height: 100vh;\n  /* Fix pro správné roztažení v mobilních prohlížečích Safari a Chrome */\n  min-height: -webkit-fill-available; \n  /* Vynutí, aby podklad webu byl čistě bílý a neprosvítala tam černá */\n  background-color: #ffffff !important; \n}\n\nbody {\n  /* Zamezí gumovému efektu při scrollování na mobilu (odskakování horní/dolní lišty), \n     který způsoboval blikání černých pruhů */\n  overscroll-behavior-y: none;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* ==========================================================================\n   SLAĎENÝ STYL PRO LEVÝ PANEL (SIDEBAR) – PODLE HORNÍ LIŠTY\n   ========================================================================== */\n\n/* 1. Pozadí panelu: Čistá, velmi tmavá antracitová barva přesně podle horní lišty */\n.sidebar-pattern {\n  background-image: none !important; /* Definitivně maže ty staré čtverečky */\n  background: #1e293b !important; /* Tmavý elegantní podklad odpovídající vršku */\n  background-color: #1e293b !important;\n  backdrop-filter: none !important; /* Už není potřeba rozmazávat fotku, panel je plný */\n  border-right: 1px solid rgba(255, 255, 255, 0.05) !important;\n}\n\n/* 2. Vynucený reset pro všechny položky v menu (Obyčejný stav) */\n.sidebar-pattern a, \n.sidebar-pattern button,\n.sidebar-pattern [role=\"button\"] {\n  font-size: 1.05rem !important;\n  color: #cbd5e1 !important; /* Příjemná světle šedá textu */\n  transition: all 0.25s ease-out !important;\n  padding: 12px 20px !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 12px !important;\n  border-radius: 0px !important; /* Zrušíme ty kulaté modré pilulky */\n  background-image: none !important;\n  text-decoration: none !important;\n}\n\n/* 3. Efekt při najetí myší (Hover) */\n.sidebar-pattern a:hover,\n.sidebar-pattern button:hover {\n  color: #4ade80 !important; /* Text se rozsvítí kempově zelenou */\n  background: rgba(255, 255, 255, 0.03) !important;\n  background-color: rgba(255, 255, 255, 0.03) !important;\n  padding-left: 26px !important; /* Stylové odskočení doprava při najetí */\n}\n\n/* 4. ABSOLUTNÍ PŘEBITÍ PRO AKTIVNÍ KARTU (Zelené zvýraznění) */\n.sidebar-pattern [class*=\"bg-blue\"],\n.sidebar-pattern .active,\n.sidebar-pattern [aria-current=\"page\"],\n.sidebar-pattern [class*=\"active\"] {\n  color: #4ade80 !important; /* Zelený text */\n  font-weight: 700 !important; /* Tučné písmo */\n  \n  /* Jemný zelený nádech pod textem, aby karta vystoupila z tmavého pozadí */\n  background: rgba(74, 222, 128, 0.12) !important; \n  background-color: rgba(74, 222, 128, 0.12) !important;\n  \n  /* Elegantní zelená svítící linka na levém okraji karty */\n  border-left: 5px solid #4ade80 !important; \n  padding-left: 26px !important; /* Karta zůstane mírně vysunutá */\n  border-radius: 0px !important;\n}\n\n/* Pojistka: Pokud jsou ikonky nebo texty schované uvnitř, donutíme je svítit zeleně taky */\n.sidebar-pattern [class*=\"bg-blue\"] *,\n.sidebar-pattern .active *,\n.sidebar-pattern [class*=\"active\"] * {\n  color: #4ade80 !important;\n  fill: #4ade80 !important; /* Pro SVG ikony */\n}\n\n/* ==========================================================================\n   ZBYTEK STYLŮ (Původní funkční nastavení)\n   ========================================================================== */\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Animation for sections */\nsection {\n  animation: fadeIn 0.5s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Input styles */\ninput[type=\"text\"] {\n  transition: all 0.3s ease;\n}\n\ninput[type=\"text\"]:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.hover-lift {\n  transition: transform 0.3s ease;\n}\n\n.hover-lift:hover {\n  transform: translateY(-5px);\n}\n\n.animate-fadeIn {\n  animation: lightboxFadeIn 0.2s ease-out;\n}\n\n@keyframes lightboxFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
